import React from 'react'
import { toast } from 'react-toastify';

import { Grid, FormControlLabel, Tooltip } from '@mui/material';
import InputColor from 'react-input-color';

// Styles
import { 
    GridCenter, 
    ImageContainer, 
    UploadButton, 
    ContainerColors, 
    ContainerButtonsDown, 
    CustomCardMedia, 
    ContainerImages, 
    CustomChip, 
    ErrorText, 
	ContentCard,
	TitleContainer,
	Subtitle,
  GridContainerColors
} from './styles'

import { AntSwitch, CustomButtonV2, CustomChipStatus, CustomFormLabel, CustomTextField } from '../../pages/styles';
import { Cancel, ImageOutlined, PaletteOutlined, RefreshOutlined, SaveOutlined, SettingsOutlined, FileUploadOutlined, DeleteOutline } from '@mui/icons-material';

import { useTranslation } from 'react-i18next'
import Router from '../../router';
import { ColorsContext } from "../../Context/ColorsContext"

// Permissions
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../Context/PermissionsContext';

export const Appearance = ({ data, errors, loading, handleChange, handleState, previewImage, removePreviewImage, previewIcon, removePreviewIcon, previewFavicon, removePreviewFavicon, previewLoginIcon, removePreviewLoginIcon, handleConfirmation, handleReset }) => {

    const MAX_SIZE_IMAGE = "2MB";

    const { t } = useTranslation();
    const { colors } = React.useContext(ColorsContext);
    const ability = useAbility(AbilityContext);

    const { file: fileIcon, status: statusIcon } = previewIcon
    const { file: fileImage, status: statusImage } = previewImage
    const { file: fileFavicon, status: statusFavicon } = previewFavicon
    const { file: fileLoginIcon, status: statusLoginIcon } = previewLoginIcon

    function handleFileChange(e, field, type) {
        let file = e.target.files[0];
      
        if (file) {
            const acceptAttribute = e.target.accept; // Obtiene el atributo accept del input
            const allowedExtensions = acceptAttribute.split(',').map(ext => ext.trim());

            const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB
            if (file.size <= maxSizeInBytes) {
                const fileExtension = file.name.slice(((file.name.lastIndexOf(".") - 1) >>> 0) + 2); // Obtener la extensión del archivo
                if (allowedExtensions.includes('.' + fileExtension.toLowerCase())) {
                    handleChange(e, field, type);
                } else {
                    toast.error( t('system.appearance.messages.uploadTypeError', {type: allowedExtensions.join(' o ')}))
                }
            } else {
                toast.error(`${t('system.appearance.sections.maxSizeImage')}: ${MAX_SIZE_IMAGE}`)
            }
        }
        file = null
    }

    return (
		<Grid container>
			<Grid item xs={12}>
				{errors.general.hasError && 
					<Grid item xs={12}>
						<ErrorText>{errors.general.message}</ErrorText>
					</Grid>
				}
			</Grid>
			
			<Grid item xs={12}>
				<ContentCard>
					<Grid container spacing={2}>
						<Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>
							<TitleContainer>
								<SettingsOutlined/>
								<CustomFormLabel sx={{ marginBottom: 0 }}>
									{t('system.appearance.appIdentity')}
								</CustomFormLabel>
							</TitleContainer>
							<Subtitle>{t('system.appearance.customizeIdentity')}</Subtitle>
						</Grid>
						
						<Grid item xs={12} md={8} lg={6} xl={4} sx={{ display: 'flex', flexDirection: 'column' }}>
							<CustomFormLabel>{t('system.appearance.titleApp')}</CustomFormLabel>
							<CustomTextField
								label={t('system.appearance.titleApp')}
								value={data.title}
								onChange={e => handleChange(e, 'title', 'text')}
								disabled={data.isActive === false}
							/>
							<Subtitle style={{ marginTop: '.5rem' }}>{t('system.appearance.displayName')}</Subtitle>
						</Grid>

					</Grid>
				</ContentCard>
			</Grid>
			
			<Grid item xs={12} mt={2}>
				<ContentCard>
					<Grid container spacing={2}>

						<Grid item xs={12} sm={6} sx={{ display: 'flex', flexDirection: 'column' }}>
							<TitleContainer>
								<PaletteOutlined/>
								<CustomFormLabel sx={{ marginBottom: 0 }}>
									{t('system.appearance.colorsPalette')}
								</CustomFormLabel>
							</TitleContainer>
							<Subtitle>{t('system.appearance.colorsPaletteDescription')}</Subtitle>
						</Grid>

						<Grid item xs={12} sm={6}
              sx={{ display: 'flex', justifyContent: {xs: 'flex-start', sm: 'flex-end'} }}>
							<FormControlLabel
								disabled={loading}
                sx={{ pl: 2 }}
								control={
									<AntSwitch
										checked={data.isActive}
										onChange={() => handleState(!data.isActive)}
										inputProps={{ 'aria-label': 'controlled' }}
									/>
								}
								label={
									<CustomChipStatus
										enabled={data.isActive}
										label={data.isActive ? t('system.appearance.active') : t('system.appearance.inactive')}
										sx={{ ml: 1 }}
									/>
								} 
							/>
						</Grid>

            <Grid item xs={5} sm={2} md={3}>
							<CustomFormLabel>{t('system.appearance.navbarColor')}</CustomFormLabel>
            </Grid>
            <Grid item xs={3} sm={2} md={1} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <InputColor
                className="input-color-picker"
                initialValue={data.navbarColor}
                onChange={(e) => handleChange(e, 'navbarColor', 'hex')}
                placement="start"
                xs={{ marginTop: '10' }}
                style={{ width: '55px', height: '32px' }}
                disabled={data.isActive === false}
              />
            </Grid>
            <Grid item xs={4} sm={2} md={2}>
              <CustomTextField
                disabled={true}
                value={data.navbarColor}
              />
            </Grid>

            <Grid item xs={5} sm={2} md={3}>
							<CustomFormLabel>{t('system.appearance.footerColor')}</CustomFormLabel>
            </Grid>
            <Grid item xs={3} sm={2} md={1} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <InputColor
                initialValue={data.footerColor}
                onChange={(e) => handleChange(e, 'footerColor', 'hex')}
                placement="start"
                xs={{ marginTop: '10' }}
                style={{ width: '55px', height: '32px' }}
                disabled={data.isActive === false}
              />
            </Grid>
            <Grid item xs={4} sm={2} md={2}>
              <CustomTextField
                disabled={true}
                value={data.footerColor}
              />
            </Grid>

            <Grid item xs={5} sm={2} md={3}>
							<CustomFormLabel>{t('system.appearance.sidebarSelectColor')}</CustomFormLabel>
            </Grid>
            <Grid item xs={3} sm={2} md={1} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <InputColor
                initialValue={data.sidebarSelectColor}
                onChange={(e) => handleChange(e, 'sidebarSelectColor', 'hex')}
                placement="start"
                xs={{ marginTop: '10' }}
                style={{ width: '55px', height: '32px' }}
                disabled={data.isActive === false}
              />
            </Grid>
            <Grid item xs={4} sm={2} md={2}>
              <CustomTextField
                disabled={true}
                value={data.sidebarSelectColor}
              />
            </Grid>

            <Grid item xs={5} sm={2} md={3}>
							<CustomFormLabel>{t('system.appearance.sectionTitleColor')}</CustomFormLabel>
            </Grid>
            <Grid item xs={3} sm={2} md={1} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <InputColor
                initialValue={data.sectionTitleColor}
                onChange={(e) => handleChange(e, 'sectionTitleColor', 'hex')}
                placement="start"
                xs={{ marginTop: '10' }}
                style={{ width: '55px', height: '32px' }}
                disabled={data.isActive === false}
              />
            </Grid>
            <Grid item xs={4} sm={2} md={2}>
              <CustomTextField
                disabled={true}
                value={data.sectionTitleColor}
              />
            </Grid>

            <Grid item xs={5} sm={2} md={3}>
							<CustomFormLabel>{t('system.appearance.buttonActionColor')}</CustomFormLabel>
            </Grid>
            <Grid item xs={3} sm={2} md={1} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <InputColor
                initialValue={data.buttonActionColor}
                onChange={(e) => handleChange(e, 'buttonActionColor', 'hex')}
                placement="start"
                xs={{ marginTop: '10' }}
                style={{ width: '55px', height: '32px' }}
                disabled={data.isActive === false}
              />
            </Grid>
            <Grid item xs={4} sm={2} md={2}>
              <CustomTextField
                disabled={true}
                value={data.buttonActionColor}
              />
            </Grid>

            <Grid item xs={5} sm={2} md={3}>
							<CustomFormLabel>{t('system.appearance.detailTextColor')}</CustomFormLabel>
            </Grid>
            <Grid item xs={3} sm={2} md={1} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <InputColor
                initialValue={data.detailTextColor}
                onChange={(e) => handleChange(e, 'detailTextColor', 'hex')}
                placement="start"
                xs={{ marginTop: '10' }}
                style={{ width: '55px', height: '32px' }}
                disabled={data.isActive === false}
              />
            </Grid>
            <Grid item xs={4} sm={2} md={2}>
              <CustomTextField
                disabled={true}
                value={data.detailTextColor}
              />
            </Grid>

					</Grid>
				</ContentCard>
			</Grid>

      <Grid item xs={12} mt={2}>
				<ContentCard>
					<Grid container spacing={2}>

						<Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>
							<TitleContainer>
								<ImageOutlined/>
								<CustomFormLabel sx={{ marginBottom: 0 }}>
									{t('system.appearance.visualResources')}
								</CustomFormLabel>
							</TitleContainer>
							<Subtitle>{t('system.appearance.visualResourcesDescription', {value: MAX_SIZE_IMAGE})}</Subtitle>
						</Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <ContainerImages>
                <div style={{ display: 'flex', flexDirection: 'column', width: '100%'}}>
                  <CustomFormLabel style={{ marginBottom: 0 }}>{t('system.appearance.imageLoginUrl')}</CustomFormLabel>
							    <Subtitle>{t('system.appearance.loginImageDescription')}</Subtitle>
							    <Subtitle style={{ fontSize: 11, color: '#bfc4cd' }}>{t('system.appearance.imageRecomendation', {value: '1920x1080px'})}</Subtitle>

                  <ImageContainer style={{ marginTop: 4 }}>
                    {((data.imageLoginUrl === '' || data.imageLoginUrl === null) && statusImage === false) ?
                      <GridCenter container direction="column">
                        <UploadButton component="label" disabled={!data.isActive}>
                          <FileUploadOutlined/>
                          {t('system.appearance.uploadImage')}
                          <input type="file" hidden accept=".jpg, .jpeg" onChange={e => handleFileChange(e, 'imageLoginUrl', 'file')} />
                        </UploadButton>
                      </GridCenter>
                      :
                      <Grid container alignItems="center">
                        <Grid item xs={12}>
                          <CustomCardMedia
                            component="img"
                            image={
                              statusImage === true
                                ? `${fileImage}`
                                : `${Router.apiBaseUrl}/${encodeURI(data.imageLoginUrl)}`
                            }
                            sx={{ objectFit: 'contain' }}
                            alt={'Login Image'}
                          />

                        </Grid>
                      </Grid>
                    }
                  </ImageContainer>
                  {(data?.imageLogin !== null || data?.imageLoginUrl !== "") &&
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 4 }}>
                      <Subtitle>
                        {data?.imageLogin !== null ?
                          data.imageLogin?.name :
                          data.imageLoginUrl?.toString().split(/[\/\\]/).pop()}
                      </Subtitle>
                      <CustomButtonV2
                        btnType="cancel"
                        sx={{ width: '40%' }}
                        startIcon={<DeleteOutline/>}
                        onClick={() => removePreviewImage()}
                      >
                        {t('files.remove')}
                      </CustomButtonV2>
                    </div>
                  }
                </div>
              </ContainerImages>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <ContainerImages>
                <div style={{ display: 'flex', flexDirection: 'column', width: '100%'}}>
                  <CustomFormLabel style={{ marginBottom: 0 }}>{t('system.appearance.iconUrl')}</CustomFormLabel>
							    <Subtitle>{t('system.appearance.navbarIconDescription')}</Subtitle>
							    <Subtitle style={{ fontSize: 11, color: '#bfc4cd' }}>{t('system.appearance.imageRecomendation', {value: '48x48px'})}</Subtitle>

                  <ImageContainer style={{ marginTop: 4 }}>
                    {((data.iconUrl === '' || data.iconUrl === null) && statusIcon === false) ?
                      <GridCenter container direction="column">
                        <UploadButton component="label" disabled={!data.isActive}>
                          <FileUploadOutlined/>
                          {t('system.appearance.uploadImage')}
                          <input type="file" hidden accept=".png" onChange={e => handleFileChange(e, 'iconUrl', 'file')} />
                        </UploadButton>
                      </GridCenter>
                      :
                      <Grid container alignItems="center">
                        <Grid item xs={12}>
                          <CustomCardMedia
                            component="img"
                            image={
                              statusIcon === true
                                ? `${fileIcon}`
                                : `${Router.apiBaseUrl}/${encodeURI(data.iconUrl)}`
                            }
                            sx={{ objectFit: 'contain' }}
                            alt={'Icon navbar'}
                          />

                        </Grid>
                      </Grid>
                    }
                  </ImageContainer>
                  {(data?.imageIcon !== null || data?.iconUrl !== "") &&
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 4 }}>
                      <Subtitle>
                        {data?.imageIcon !== null ?
                          data.imageIcon?.name :
                          data.iconUrl?.toString().split(/[\/\\]/).pop()}
                      </Subtitle>
                      <CustomButtonV2
                        btnType="cancel"
                        sx={{ width: '40%' }}
                        startIcon={<DeleteOutline/>}
                        onClick={() => removePreviewIcon()}
                      >
                        {t('files.remove')}
                      </CustomButtonV2>
                    </div>
                  }
                </div>
              </ContainerImages>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <ContainerImages>
                <div style={{ display: 'flex', flexDirection: 'column', width: '100%'}}>
                  <CustomFormLabel style={{ marginBottom: 0 }}>{t('system.appearance.favicon')}</CustomFormLabel>
                  <Subtitle>{t('system.appearance.faviconDescription')}</Subtitle>
							    <Subtitle style={{ fontSize: 11, color: '#bfc4cd' }}>{t('system.appearance.imageRecomendation', {value: '48x48px'})}</Subtitle>

                  <ImageContainer style={{ marginTop: 4 }}>
                    {((data.faviconUrl === '' || data.faviconUrl === null) && statusFavicon === false) ?
                      <GridCenter container direction="column">
                        <UploadButton component="label" disabled={!data.isActive}>
                          <FileUploadOutlined/>
                          {t('system.appearance.uploadImage')}
                          <input type="file" hidden accept=".ico" onChange={e => handleFileChange(e, 'faviconUrl', 'file')} />
                        </UploadButton>
                      </GridCenter>
                      :
                      <Grid container alignItems="center">
                        <Grid item xs={12}>
                          <CustomCardMedia
                            component="img"
                            image={
                              statusFavicon === true
                                ? `${fileFavicon}`
                                : `${Router.apiBaseUrl}/${encodeURI(data.faviconUrl)}`
                            }
                            sx={{ objectFit: 'contain' }}
                            alt={'Favicon image'}
                          />

                        </Grid>
                      </Grid>
                    }
                  </ImageContainer>
                  {(data?.faviconImage !== null || data?.faviconUrl !== "") &&
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 4 }}>
                      <Subtitle>
                        {data?.faviconImage !== null ?
                          data.faviconImage?.name :
                          data.faviconUrl?.toString().split(/[\/\\]/).pop()}
                      </Subtitle>
                      <CustomButtonV2
                        btnType="cancel"
                        sx={{ width: '40%' }}
                        startIcon={<DeleteOutline/>}
                        onClick={() => removePreviewFavicon()}
                      >
                        {t('files.remove')}
                      </CustomButtonV2>
                    </div>
                  }
                </div>
              </ContainerImages>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <ContainerImages>
                <div style={{ display: 'flex', flexDirection: 'column', width: '100%'}}>
                  <CustomFormLabel style={{ marginBottom: 0 }}>{t('system.appearance.loginIcon')}</CustomFormLabel>
                  <Subtitle>{t('system.appearance.loginIconDescription')}</Subtitle>
							    <Subtitle style={{ fontSize: 11, color: '#bfc4cd' }}>{t('system.appearance.imageRecomendation', {value: '128x128px'})}</Subtitle>

                  <ImageContainer style={{ marginTop: 4 }}>
                    {((data.loginIconUrl === '' || data.loginIconUrl === null) && statusLoginIcon === false) ?
                      <GridCenter container direction="column">
                        <UploadButton component="label" disabled={!data.isActive}>
                          <FileUploadOutlined/>
                          {t('system.appearance.uploadImage')}
                          <input type="file" hidden accept=".png" onChange={e => handleFileChange(e, 'loginIconUrl', 'file')} />
                        </UploadButton>
                      </GridCenter>
                      :
                      <Grid container alignItems="center">
                        <Grid item xs={12}>
                          <CustomCardMedia
                            component="img"
                            image={
                              statusLoginIcon === true
                                ? `${fileLoginIcon}`
                                : `${Router.apiBaseUrl}/${encodeURI(data.loginIconUrl)}`
                            }
                            sx={{ objectFit: 'contain' }}
                            alt={'Login icon image'}
                          />

                        </Grid>
                      </Grid>
                    }
                  </ImageContainer>
                  {(data?.loginImageIcon !== null || data?.loginIconUrl !== "") &&
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 4 }}>
                      <Subtitle>
                        {data?.loginImageIcon !== null ?
                          data.loginImageIcon?.name :
                          data.loginIconUrl?.toString().split(/[\/\\]/).pop()}
                      </Subtitle>
                      <CustomButtonV2
                        btnType="cancel"
                        sx={{ width: '40%' }}
                        startIcon={<DeleteOutline/>}
                        onClick={() => removePreviewLoginIcon()}
                      >
                        {t('files.remove')}
                      </CustomButtonV2>
                    </div>
                  }
                </div>
              </ContainerImages>
            </Grid>

          </Grid>
        </ContentCard>
      </Grid>

      <Grid item xs={12} sm={6} md={7} lg={8} xl={9}></Grid>

      <Grid item xs={12} sm={6} md={5} lg={4} xl={3}>
        <ContainerButtonsDown>
          <CustomButtonV2
            btnType="close"
            startIcon={<RefreshOutlined/>}
            onClick={() => handleReset()}
            disabled={loading}
          >
            {t('system.appearance.resetAppearance')}
          </CustomButtonV2>
          
          {ability.can("UpdateAppearance") &&
            <CustomButtonV2
              btnType="primary"
              startIcon={<SaveOutlined/>}
              onClick={() => handleConfirmation()}
              disabled={loading}
            >
              {t('common.save')}
            </CustomButtonV2>
          }
        </ContainerButtonsDown>
      </Grid>

		</Grid>
    )
}